// // import styled from 'styled-components';
// // import { animated } from 'react-spring';
// // import { darken } from 'polished';

// // export const Container = styled.div`
// //   /* flex: 1;
// //   display: flex; */
// // `;

// // export const List = styled.div`
// //   flex: 1;
// //   /* display: flex;
// //   flex-wrap: wrap;
// //   justify-content: center; */
// //   padding: 40px 60px;

// //   height: 100%;
// //   max-height: calc(100vh - 250px);
// //   overflow-y: auto;
// // `;

// // List.WrapperCard = styled.div`
// //   /* flex: 1; */
// //   display: flex;
// //   flex-wrap: wrap;
// //   justify-content: center;
// // `;

// // List.WrapperImgCard = styled.div`
// //   /* flex: 1; */
// //   display: flex;
// //   flex-wrap: wrap;
// //   justify-content: center;
// // `;

// // List.Card = styled(animated.div)`
// //   display: flex;
// //   background: #fff;
// //   box-shadow: 0px 3px 6px #00000026;
// //   border-radius: 10px;
// //   margin: 10px 20px;
// //   min-height: 50px;
// //   width: 100%;
// //   max-width: 500px;

// //   a {
// //     display: flex;
// //     align-items: center;
// //     justify-content: center;
// //     font-size: 14px;
// //     color: #2c405a;
// //     text-decoration: none;
// //     height: 100%;
// //     width: 100%;
// //     text-align: center;
// //     border-radius: inherit;
// //     padding: 5px;

// //     :hover {
// //       /* background: ${darken(0.05, '#fff')}; */
// //       border: 1px solid #ccc;
// //     }
// //   }
// // `;

// // List.ImgCard = styled(animated.div)`
// //   display: flex;
// //   background: #fff;
// //   box-shadow: 0px 3px 6px #00000026;
// //   border-radius: 10px;
// //   margin: 10px 20px;
// //   height: 250px;
// //   width: 100%;
// //   max-width: 250px;

// //   a {
// //     display: flex;
// //     flex-direction: column;
// //     align-items: center;
// //     justify-content: center;
// //     font-size: 14px;
// //     color: #2c405a;
// //     text-decoration: none;
// //     height: 100%;
// //     width: 100%;
// //     border-radius: inherit;
// //     text-align: center;

// //     :hover {
// //       /* background: ${darken(0.05, '#fff')}; */
// //       border: 1px solid #ccc;
// //     }

// //     img {
// //       height: 200px;
// //       width: 200px;
// //     }
// //   }
// // `;

// import styled from 'styled-components';
// import { animated } from 'react-spring';

// /* ===== Identidade visual (alinhada ao login / Header) =====
//    --primary: #ff6d3c   --ink: #2c405a / #17263b
//    --border: rgba(216, 224, 235, 0.9)
// =========================================================== */

// export const Container = styled.div`
//   width: 100%;
// `;

// export const List = styled.div`
//   flex: 1;
//   height: 100%;
//   max-height: calc(100vh - 250px);
//   padding: 40px 60px;
//   overflow-y: auto;

//   @media (max-width: 700px) {
//     padding: 24px 20px;
//   }
// `;

// List.WrapperCard = styled.div`
//   display: flex;
//   flex-wrap: wrap;
//   justify-content: center;
// `;

// List.WrapperImgCard = styled.div`
//   display: flex;
//   flex-wrap: wrap;
//   justify-content: center;
// `;

// List.Card = styled(animated.div)`
//   display: flex;
//   width: 100%;
//   max-width: 500px;
//   min-height: 50px;
//   margin: 10px 20px;

//   background: #fff;
//   border: 1px solid rgba(216, 224, 235, 0.9);
//   border-radius: 14px;
//   box-shadow: 0 6px 16px rgba(23, 38, 59, 0.08);
//   transition: box-shadow 0.25s ease, border-color 0.25s ease,
//     transform 0.25s ease;

//   &:hover {
//     border-color: rgba(255, 109, 60, 0.4);
//     box-shadow: 0 14px 30px rgba(23, 38, 59, 0.14);
//     transform: translateY(-2px);
//   }

//   a {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     height: 100%;
//     width: 100%;
//     padding: 14px 16px;
//     border-radius: inherit;
//     text-align: center;
//     text-decoration: none;
//     font-size: 15px;
//     font-weight: 600;
//     color: #2c405a;
//     transition: color 0.2s ease;

//     :hover {
//       color: #ff6d3c;
//     }
//   }
// `;

// List.ImgCard = styled(animated.div)`
//   display: flex;
//   height: 250px;
//   width: 100%;
//   max-width: 250px;
//   margin: 10px 20px;
//   overflow: hidden;

//   background: #fff;
//   border: 1px solid rgba(216, 224, 235, 0.9);
//   border-radius: 16px;
//   box-shadow: 0 6px 16px rgba(23, 38, 59, 0.08);
//   transition: box-shadow 0.25s ease, border-color 0.25s ease,
//     transform 0.25s ease;

//   &:hover {
//     border-color: rgba(255, 109, 60, 0.4);
//     box-shadow: 0 16px 34px rgba(23, 38, 59, 0.16);
//     transform: translateY(-3px);
//   }

//   a {
//     display: flex;
//     flex-direction: column;
//     align-items: center;
//     justify-content: center;
//     gap: 8px;
//     height: 100%;
//     width: 100%;
//     padding: 12px;
//     border-radius: inherit;
//     text-align: center;
//     text-decoration: none;
//     font-size: 14px;
//     font-weight: 600;
//     color: #2c405a;
//     transition: color 0.2s ease;

//     :hover {
//       color: #ff6d3c;
//     }

//     img {
//       height: 200px;
//       width: 200px;
//       object-fit: contain;
//       border-radius: 10px;
//     }
//   }
// `;

// import styled from 'styled-components';
// import { animated } from 'react-spring';
// import { darken } from 'polished';

// export const Container = styled.div`
//   /* flex: 1;
//   display: flex; */
// `;

// export const List = styled.div`
//   flex: 1;
//   /* display: flex;
//   flex-wrap: wrap;
//   justify-content: center; */
//   padding: 40px 60px;

//   height: 100%;
//   max-height: calc(100vh - 250px);
//   overflow-y: auto;
// `;

// List.WrapperCard = styled.div`
//   /* flex: 1; */
//   display: flex;
//   flex-wrap: wrap;
//   justify-content: center;
// `;

// List.WrapperImgCard = styled.div`
//   /* flex: 1; */
//   display: flex;
//   flex-wrap: wrap;
//   justify-content: center;
// `;

// List.Card = styled(animated.div)`
//   display: flex;
//   background: #fff;
//   box-shadow: 0px 3px 6px #00000026;
//   border-radius: 10px;
//   margin: 10px 20px;
//   min-height: 50px;
//   width: 100%;
//   max-width: 500px;

//   a {
//     display: flex;
//     align-items: center;
//     justify-content: center;
//     font-size: 14px;
//     color: #2c405a;
//     text-decoration: none;
//     height: 100%;
//     width: 100%;
//     text-align: center;
//     border-radius: inherit;
//     padding: 5px;

//     :hover {
//       /* background: ${darken(0.05, '#fff')}; */
//       border: 1px solid #ccc;
//     }
//   }
// `;

// List.ImgCard = styled(animated.div)`
//   display: flex;
//   background: #fff;
//   box-shadow: 0px 3px 6px #00000026;
//   border-radius: 10px;
//   margin: 10px 20px;
//   height: 250px;
//   width: 100%;
//   max-width: 250px;

//   a {
//     display: flex;
//     flex-direction: column;
//     align-items: center;
//     justify-content: center;
//     font-size: 14px;
//     color: #2c405a;
//     text-decoration: none;
//     height: 100%;
//     width: 100%;
//     border-radius: inherit;
//     text-align: center;

//     :hover {
//       /* background: ${darken(0.05, '#fff')}; */
//       border: 1px solid #ccc;
//     }

//     img {
//       height: 200px;
//       width: 200px;
//     }
//   }
// `;

import styled from 'styled-components';
import { animated } from 'react-spring';

/* ===== Identidade visual (alinhada ao login / Header) =====
   --primary: #ff6d3c   --ink: #2c405a / #17263b
   --border: rgba(216, 224, 235, 0.9)
=========================================================== */

export const Container = styled.div`
  /**
   * Acompanha o flex do Content (Classificacao) em vez de altura fixa,
   * evitando rolagem dupla em telas de 800px de altura.
   */
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  min-height: 0;
  width: 100%;
`;

export const List = styled.div`
  flex: 1 1 auto;
  min-height: 0;
  padding: 28px 40px;
  overflow-y: auto;

  @media (max-width: 1440px), (max-height: 900px) {
    padding: 18px 24px;
  }

  @media (max-width: 700px) {
    padding: 24px 20px;
  }
`;

List.WrapperCard = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

List.WrapperImgCard = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
`;

List.Card = styled(animated.div)`
  display: flex;
  width: 100%;
  max-width: 500px;
  min-height: 50px;
  margin: 10px 20px;

  background: #fff;
  border: 1px solid rgba(216, 224, 235, 0.9);
  border-radius: 14px;
  box-shadow: 0 6px 16px rgba(23, 38, 59, 0.08);
  transition: box-shadow 0.25s ease, border-color 0.25s ease,
    transform 0.25s ease;

  &:hover {
    border-color: rgba(255, 109, 60, 0.4);
    box-shadow: 0 14px 30px rgba(23, 38, 59, 0.14);
    transform: translateY(-2px);
  }

  a {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
    width: 100%;
    padding: 14px 16px;
    border-radius: inherit;
    text-align: center;
    text-decoration: none;
    font-size: 15px;
    font-weight: 600;
    color: #2c405a;
    transition: color 0.2s ease;

    :hover {
      color: #ff6d3c;
    }
  }
`;

List.ImgCard = styled(animated.div)`
  display: flex;
  height: 250px;
  width: 100%;
  max-width: 250px;
  margin: 10px 20px;
  overflow: hidden;

  background: #fff;
  border: 1px solid rgba(216, 224, 235, 0.9);
  border-radius: 16px;
  box-shadow: 0 6px 16px rgba(23, 38, 59, 0.08);
  transition: box-shadow 0.25s ease, border-color 0.25s ease,
    transform 0.25s ease;

  &:hover {
    border-color: rgba(255, 109, 60, 0.4);
    box-shadow: 0 16px 34px rgba(23, 38, 59, 0.16);
    transform: translateY(-3px);
  }

  a {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 8px;
    height: 100%;
    width: 100%;
    padding: 12px;
    border-radius: inherit;
    text-align: center;
    text-decoration: none;
    font-size: 14px;
    font-weight: 600;
    color: #2c405a;
    transition: color 0.2s ease;

    :hover {
      color: #ff6d3c;
    }

    img {
      height: 200px;
      width: 200px;
      object-fit: contain;
      border-radius: 10px;
    }
  }
`;
